import { render, staticRenderFns } from "./DraggableFiles.vue?vue&type=template&id=6050417d&scoped=true&lang=pug"
import script from "./DraggableFiles.vue?vue&type=script&lang=ts"
export * from "./DraggableFiles.vue?vue&type=script&lang=ts"
import style0 from "./DraggableFiles.vue?vue&type=style&index=0&id=6050417d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050417d",
  null
  
)

export default component.exports